<template>
  <div class="complaint">
    <el-steps v-if="!showStatement[0]" :active="stepAction" finish-status="success" process-status="finish" align-center>
      <el-step :title="$t('complaintForm.title1')" />
      <el-step :title="$t('complaintForm.title2')" />
      <el-step :title="$t('complaintForm.title3')" />
      <el-step :title="$t('complaintForm.title4')" />
    </el-steps>
    <div class="complaint-content">
      <div v-if="stepAction === 0 && showStatement[0]" class="statement" :class="$store.getters.language !== 'zh' ? '' : 'statement-zh'">
        <div class="statement-title">{{ statementTitle[stepAction] }}</div>
        <p class="statement-text" v-html="$tc('statementText.stepActionText0', 1)"></p>
        <p class="statement-text" v-html="$tc('statementText.stepActionText0', 2)"></p>
<!--        <el-checkbox v-model="statementChecked" :disabled="statementCountDown !== 0">{{ $t('statementText.statementChecked') }}</el-checkbox>-->
        <div style="text-align: center;width: 100%">
          <el-button type="primary" :disabled="statementCountDown !== 0 || !statementChecked" @click="haveRead">{{ statementCountDown!==0 ? statementCountDown+'s' : '' }} {{ $t('statementText.statementChecked') }}</el-button>
        </div>
      </div>
      <el-dialog
        class="statement"
        :class="$store.getters.language !== 'zh' ? '' : 'statement-zh'"
        :visible.sync="stepAction !== 0 && showStatement[stepAction]"
        :show-close="false"
        :close-on-press-escape="false"
        :close-on-click-modal=" false"
        center
        width="600px"
      >
        <div slot="title" class="statement-title">{{ statementTitle[stepAction] }}</div>
        <div v-if="stepAction === 1">
          <p class="statement-text" v-html="$tc('statementText.stepActionText1', 0)"></p>
          <p class="statement-text" v-html="$tc('statementText.stepActionText1', 1)"></p>
          <p class="statement-text" v-html="$tc('statementText.stepActionText1', 2)"></p>
        </div>
        <div v-if="stepAction === 2">
          <p class="statement-text" v-html="$tc('statementText.stepActionText2', 0)"></p>
          <p class="statement-text" v-html="$tc('statementText.stepActionText2', 1)"></p>
          <p class="statement-text" v-html="$tc('statementText.stepActionText2', 2)"></p>
        </div>
        <el-checkbox v-model="statementChecked" :disabled="statementCountDown !== 0">{{ $t('statementText.statementChecked') }}</el-checkbox>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" :disabled="statementCountDown !== 0 || !statementChecked" @click="haveRead">{{ statementCountDown!==0 ? statementCountDown+'s' : '' }} {{ $t('statementText.statementButton') }}</el-button>
        </span>
      </el-dialog>
      <div>
        <el-form v-if="stepAction === 0 && !showStatement[0]" ref="regionForm" :model="complaintForm" :rules="regionRules" label-position="right" label-width="260px" class="submit-form">
          <el-row>
            <el-col :span="24">
              <p class="title">{{ $t('complaintForm.title1') }}</p>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="$t('complaintForm.located')" prop="located">
                <el-input v-model="complaintForm.located" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('complaintForm.misconductOccur')" prop="misconductOccur">
                <el-input v-model="complaintForm.misconductOccur" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="form-next-btn">
              <el-button type="primary" prop="nextStep" @click="nextStep('regionForm')">{{ $t('complaintForm.nextStep') }}</el-button>
            </el-col>
          </el-row>
        </el-form>
        <el-form v-if="stepAction === 1" ref="complainantForm" :model="complaintForm" :rules="complainantRules" label-position="top" label-width="220px" class="submit-form">
          <el-row>
            <el-col :span="24" class="colCenter">
              <p class="title">{{ $t('complaintForm.title2') }}</p>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12" class="colCenter">
              <el-form-item :label="$tc('relation.question', 0)" prop="limited">
                <el-select v-model="complaintForm.limited" :placeholder="$t('relation.choose')">
                  <el-option :label="$t('relation.limiteds.value1')" :value="1" />
                  <el-option :label="$t('relation.limiteds.value2')" :value="2" />
                  <el-option :label="$t('relation.limiteds.value3')" :value="3" />
                  <el-option :label="$t('relation.limiteds.value4')" :value="4" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col v-if="complaintForm.limited === 1" :span="12" class="colCenter">
              <el-form-item :label="$tc('relation.limitedOther', 1)" prop="department">
                <el-input v-model="complaintForm.department" />
              </el-form-item>
            </el-col>
            <el-col v-if="complaintForm.limited === 4" :span="12" class="colCenter">
              <el-form-item :label="$tc('relation.limitedOther', 2)" prop="limitedText">
                <el-input v-model="complaintForm.limitedText" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 10px">
            <el-col :span="12" class="colCenter">
              <el-form-item :label="$tc('relation.question', 1)" prop="contactInformationFlag">
                <el-select v-model="complaintForm.contactInformationFlag" :placeholder="$t('relation.choose')">
                  <el-option :label="$tc('relation.select', 1)" value="1" />
                  <el-option :label="$tc('relation.select', 2)" value="2" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="complaintForm.contactInformationFlag === '1'" :gutter="20">
            <el-col :span="12" class="colCenter">
              <el-form-item :label="$t('relation.telephone')" prop="telephone">
                <el-input v-model="complaintForm.telephone" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="complaintForm.contactInformationFlag === '1'" :gutter="20">
            <el-col :span="12" class="colCenter">
              <el-form-item :label="$t('relation.email')" prop="email">
                <el-input v-model="complaintForm.email" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 10px">
            <el-col :span="12" class="colCenter">
              <el-form-item :label="$tc('relation.question', 2)" prop="anonymousFlag">
                <el-select v-model="complaintForm.anonymousFlag" :placeholder="$t('relation.choose')">
                  <el-option :label="$tc('relation.select', 1)" value="1" />
                  <el-option :label="$tc('relation.select', 2)" value="2" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col v-if="complaintForm.anonymousFlag === '2'" :span="12" class="colCenter">
              <el-form-item :label="$t('relation.complainName')" prop="complainName">
                <el-input v-model="complaintForm.complainName" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="form-next-btn">
              <el-button type="primary" @click="previousStep">{{ $tc('relation.button', 1) }}</el-button>
              <el-button type="primary" @click="nextStep('complainantForm')">{{ $tc('relation.button', 2) }}</el-button>
            </el-col>
          </el-row>
        </el-form>

        <el-form v-if="stepAction === 2" ref="complaintForm" :model="complaintForm" :rules="complaintRules" label-position="top" label-width="180px" class="submit-form">
          <el-row>
            <el-col :span="24">
              <p class="title">{{ $t('complaintForm.title3') }}</p>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="$t('complaintForm.type')" prop="type">
                <el-select v-model="complaintForm.type" :placeholder="$t('complaintForm.pleaseSelect')">
                  <el-option
                    v-for="item in complainTypeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('complaintForm.eventTime')" prop="eventTime">
                <el-tooltip class="item" effect="dark" :content="$t('complaintForm.content')" placement="top">
                  <el-date-picker v-model="complaintForm.eventTime" type="date" :placeholder="$t('complaintForm.pleaseSelectTimes')" value-format="yyyy-MM-dd" style="width: 100%;" />
                </el-tooltip>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="$t('complaintForm.times')" prop="times">
                <el-input v-model="complaintForm.times" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('complaintForm.frequency')" prop="frequency">
                <el-input v-model="complaintForm.frequency" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="$t('complaintForm.continueFlag')" prop="continueFlag">
                <el-select v-model="complaintForm.continueFlag" :placeholder="$t('complaintForm.pleaseSelect')">
                  <el-option :label="$t('complaintForm.continueFlagSelect.yes')" value="yes" />
                  <el-option :label="$t('complaintForm.continueFlagSelect.no')" value="no" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item :label="$t('complaintForm.eventPlayers')" prop="eventPlayers">
                <el-table
                  :data="eventPlayers"
                  border
                  size="mini"
                  style="width: 100%"
                >
                  <el-table-column
                    prop="userName"
                    :label="$t('complaintForm.eventPlayersForms.userName')"
                    width="180"
                  >
                    <template slot-scope="scope">
                      <el-input v-model="eventPlayers[scope.$index].userName" />
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="department"
                    :label="$t('complaintForm.eventPlayersForms.department')"
                    width="180"
                  >
                    <template slot-scope="scope">
                      <el-input v-model="eventPlayers[scope.$index].department" />
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="position"
                    :label="$t('complaintForm.eventPlayersForms.position')"
                  >
                    <template slot-scope="scope">
                      <el-input v-model="eventPlayers[scope.$index].position" />
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="managerFlag"
                    :label="$t('complaintForm.eventPlayersForms.managerFlag')"
                  >
                    <template slot-scope="scope">
                      <el-select v-model="eventPlayers[scope.$index].managerFlag" :placeholder="$t('complaintForm.pleaseSelect')">
                        <el-option :label="$t('complaintForm.continueFlagSelect.yes')" value="yes" />
                        <el-option :label="$t('complaintForm.continueFlagSelect.no')" value="no" />
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="operation"
                    :label="$t('complaintForm.eventPlayersForms.operation')"
                  >
                    <template slot-scope="scope">
                      <el-button
                        size="mini"
                        type="danger"
                        prop="delete"
                        @click="handleDeleteParticipant(scope.$index, scope.row)"
                      >{{ $t('complaintForm.eventPlayersForms.delete') }}</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-button
                  type="primary"
                  size="small"
                  style="margin-top: 5px"
                  prop="handleAddParticipant"
                  @click="handleAddParticipant()"
                >{{ $t('complaintForm.eventPlayersForms.handleAddParticipant') }}</el-button>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item :label="$t('complaintForm.desInformation')" prop="desInformation">
                <el-input v-model="complaintForm.desInformation" type="textarea" :rows="4" :placeholder="desInformationPlaceholder" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12" class="longLabel">
              <el-form-item :label="$t('complaintForm.speechCompanyFlagFlag')" prop="speechCompanyFlagFlag">
                <el-select v-model="complaintForm.speechCompanyFlagFlag" :placeholder="$t('complaintForm.pleaseSelect')">
                  <el-option :label="$t('complaintForm.continueFlagSelect.yes')" value="1" />
                  <el-option :label="$t('complaintForm.continueFlagSelect.no')" value="2" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="complaintForm.speechCompanyFlagFlag === '1'">
            <el-col :span="24">
              <el-form-item :label="$t('complaintForm.speechCompanyFlag')" prop="speechCompanyFlag">
                <el-input v-model="complaintForm.speechCompanyFlag" type="textarea" :rows="3" :placeholder="speechCompanyFlagPlaceholder" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="$t('complaintForm.speechOtherFlagFlag')" prop="speechOtherFlagFlag">
                <el-select v-model="complaintForm.speechOtherFlagFlag" :placeholder="$t('complaintForm.pleaseSelect')">
                  <el-option :label="$t('complaintForm.continueFlagSelect.yes')" value="1" />
                  <el-option :label="$t('complaintForm.continueFlagSelect.no')" value="2" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="complaintForm.speechOtherFlagFlag === '1'">
            <el-col :span="24">
              <el-form-item :label="$t('complaintForm.speechOtherFlag')" prop="speechOtherFlag">
                <el-input v-model="complaintForm.speechOtherFlag" type="textarea" :rows="3" :placeholder="speechOtherFlagPlaceholder" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="$t('complaintForm.aboutOtherFlag')" prop="aboutOtherFlag">
                <el-select v-model="complaintForm.aboutOtherFlag" :placeholder="$t('complaintForm.pleaseSelect')">
                  <el-option :label="$t('complaintForm.aboutOtherFlagSelect.yes')" value="yes" />
                  <el-option :label="$t('complaintForm.aboutOtherFlagSelect.no')" value="no" />
                  <el-option :label="$t('complaintForm.aboutOtherFlagSelect.unKnown')" value="unKnown" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col v-if="complaintForm.aboutOtherFlag === 'yes'" :span="12">
              <el-form-item :label="$t('complaintForm.otherDepartment')" prop="otherDepartment">
                <el-input v-model="complaintForm.otherDepartment" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="$t('complaintForm.witnessName')" prop="witnessName">
                <el-select v-model="complaintForm.witnessName" :placeholder="$t('complaintForm.pleaseSelect')">
                  <el-option :label="$t('complaintForm.witnessNameSelect.yes')" value="yes" />
                  <el-option :label="$t('complaintForm.witnessNameSelect.no')" value="no" />
                  <el-option :label="$t('complaintForm.witnessNameSelect.disclose')" value="disclose" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col v-if="complaintForm.witnessName !== 'yes'" :span="12">
              <el-form-item :label="$t('complaintForm.howToKnow')" prop="howToKnow">
                <el-select v-model="complaintForm.howToKnow" :placeholder="$t('complaintForm.pleaseSelect')">
                  <el-option :label="$t('complaintForm.howToKnowSelect.victim')" value="victim" />
                  <el-option :label="$t('complaintForm.howToKnowSelect.participant')" value="participant" />
                  <el-option :label="$t('complaintForm.howToKnowSelect.witness')" value="witness" />
                  <el-option :label="$t('complaintForm.howToKnowSelect.overhearing')" value="overhearing" />
                  <el-option :label="$t('complaintForm.howToKnowSelect.rumours')" value="rumours" />
                  <el-option :label="$t('complaintForm.howToKnowSelect.disclose')" value="disclose" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="complaintForm.witnessName === 'yes'">
            <el-col>
              <el-form-item :label="$t('complaintForm.authenticatorList')" prop="authenticatorList">
                <el-table
                  :data="authenticatorList"
                  border
                  size="mini"
                  style="width: 100%"
                >
                  <el-table-column
                    prop="userName"
                    :label="$t('complaintForm.authenticatorListTable.userName')"
                    width="180"
                  >
                    <template slot-scope="scope">
                      <el-input v-model="authenticatorList[scope.$index].userName" />
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="department"
                    :label="$t('complaintForm.authenticatorListTable.department')"
                    width="180"
                  >
                    <template slot-scope="scope">
                      <el-input v-model="authenticatorList[scope.$index].department" />
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="position"
                    :label="$t('complaintForm.authenticatorListTable.position')"
                  >
                    <template slot-scope="scope">
                      <el-input v-model="authenticatorList[scope.$index].position" />
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="operation"
                    :label="$t('complaintForm.authenticatorListTable.operation')"
                  >
                    <template slot-scope="scope">
                      <el-button
                        size="mini"
                        type="danger"
                        @click="handleDeleteWitness(scope.$index)"
                      >{{ $t('complaintForm.authenticatorListTable.delete') }}</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-button
                  type="primary"
                  size="small"
                  style="margin-top: 5px"
                  @click="handleAddWitness()"
                >{{ $t('complaintForm.authenticatorListTable.handleAddWitness') }}</el-button>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="complaintForm.witnessName === 'yes'">
            <el-col :span="12">
              <el-form-item :label="$t('complaintForm.howToKnow')" prop="howToKnow">
                <el-select v-model="complaintForm.howToKnow" :placeholder="$t('complaintForm.pleaseSelect')">
                  <el-option :label="$t('complaintForm.howToKnowSelect.victim')" value="victim" />
                  <el-option :label="$t('complaintForm.howToKnowSelect.participant')" value="participant" />
                  <el-option :label="$t('complaintForm.howToKnowSelect.witness')" value="witness" />
                  <el-option :label="$t('complaintForm.howToKnowSelect.overhearing')" value="overhearing" />
                  <el-option :label="$t('complaintForm.howToKnowSelect.rumours')" value="rumours" />
                  <el-option :label="$t('complaintForm.howToKnowSelect.disclose')" value="disclose" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="el-upload__tip" style="font-size: 15px;">{{ $t('complaintForm.uploadTip3') }}<span style="color: #ff4949;">{{ adminEmailOrNumber }}</span></div>
          <!--          <el-row>
                      <el-col :span="24">
                        <el-form-item label="识别密码" prop="formKey">
                          <el-input v-model="complaintForm.formKey" placeholder="请填写识别密码，该密码是对投诉事件的跟进凭据，请妥善保存。"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item :label="$t('complaintForm.sysFiles')" prop="sysFiles">
                <el-upload
                  ref="fileUpload"
                  :action="fileAction"
                  :on-success="saveFile"
                  :on-exceed="fileExceed"
                  :before-upload="beforeUpload"
                  :before-remove="remove"
                  :limit="10"
                  accept=".jpg,.png,.gif,.mp4,.flv,.wmv,.avi,.mkv,.txt,.xlsx,.xls,.vsdx,.docx,.doc,.ppt,.pptx"
                >
                  <div slot="tip" class="el-upload__tip">{{ $t('complaintForm.uploadTip1') }}</div>
                  <div slot="tip" class="el-upload__tip">{{ $t('complaintForm.uploadTip2') }}{{ adminEmailOrNumber }}</div>
                  <el-button size="small" type="primary">{{ $t('complaintForm.uploadButton') }}</el-button>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>-->
          <el-row>
            <el-col :span="24" class="form-next-btn">
              <el-button type="primary" @click="previousStep">{{ $t('complaintForm.previousStep') }}</el-button>
              <el-button type="primary" icon="el-icon-check" @click="submitForm('complaintForm')">{{ $t('complaintForm.submitForm') }}</el-button>
            </el-col>
          </el-row>
        </el-form>
        <div v-if="stepAction === 4" class="complaint-confirmation">
          <p>{{ $t('complaintConfirmation.complaint') }}</p>
          <div>
            <p>{{ $t('complaintConfirmation.number') }}<span class="form-id">{{ formId }}</span></p>
            <p>{{ $t('complaintConfirmation.password') }}<span class="form-id">{{ formKey }}</span></p>
          </div>
          <br>
          <p>{{ $t('complaintConfirmation.help1') }}</p><br>
          <p>{{ $t('complaintConfirmation.help2') }}</p>
        </div>
      </div>
    </div>
    <div id="imgCode" />
  </div>
</template>

<script>
import { getQuestionDicts } from '@/api/system/dict/data'
import {saveComplaint, getCodeImg, sendEmail} from '@/api/home/home'
import '@/utils/slide'
import $ from 'jquery'
export default {
  name: 'Home',
  data() {
    return {
      complaintForm: {
        located: '', // 投诉人所在国家/城市
        misconductOccur: '', // 被投诉事件发生国家/城市
        limited: '', // 您与中海油的关系
        department: '', // 所在部门
        otherDepartment: '', // 外部组织机构名称
        telephone: '', // 投诉人电话
        email: '', // 投诉人电子邮箱
        complainName: '', // 投诉人姓名
        type: '', // 投诉类型
        eventTime: '', // 被投诉事件发生时间
        times: '', // 被投诉事件发生次数
        frequency: '', // 被投诉事件发生频率
        continueFlag: '', // 被投诉事件是否仍在持续
        desInformation: '', // 被投诉事件内容
        speechCompanyFlag: '', // 向公司管理层或有关部门上报此事文字详情
        speechOtherFlag: '', // 向其他外部机构上报此事文字详情
        aboutOtherFlag: '', // 被投诉事件是否涉及外部组织/机构
        witnessName: '', // 被投诉事件有无其他证明人
        fileName: '', // 附件名
        howToKnow: '', // 如何知晓此事件
        // 后端不需要的字段
        // formKey: '', // 识别密码
        limitedText: '', // 关系明确信息
        contactInformationFlag: '', // 是否愿意留联系方式
        anonymousFlag: '', // 是否匿名
        speechCompanyFlagFlag: '', // 是否曾向公司管理层或有关部门上报此事？
        speechOtherFlagFlag: '' // 是否曾向其他外部机构上报此事？
      },
      eventPlayers: [{ userName: '', department: '', position: '', managerFlag: '' }],
      authenticatorList: [{ userName: '', department: '', position: '' }],
      sysFiles: [],
      imgCode: null,
      fileAction: decodeURIComponent(window.atob(process.env.VUE_APP_BASE_API)) + '/manage/uploadFile',
      // 新
      statementCountDown: 10,
      stepAction: 0,
      showStatement: [true, true, true],
      adminEmailOrNumber: '',
      formId: '',
      formKey: '',
      statementChecked: true,
      saveComplaintFlag: false // 解决重复触发提交
    }
  },
  computed: {
    regionRules() {
      return {
        located: [{ required: true, trigger: 'blur', message: this.$t('relation.regionRules.located') },{ min: 1, max: 510, message: this.$t('relation.regionRules.locatedLimit'), trigger: 'blur' }],
        misconductOccur: [{ required: true, trigger: 'blur', message: this.$t('relation.regionRules.misconductOccur') },{ min: 1, max: 510, message: this.$t('relation.regionRules.misconductOccurLimit'), trigger: 'blur' }]
      }
    },
    complainantRules() {
      // 表单验证
      const validateEmail = (rule, value, callback) => {
        const reg = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
        if (!reg.test(value) && value !== '') {
          callback(new Error(this.$t('relation.emailError')))
        } else if(value.length > 510){
          callback(new Error(this.$t('relation.complainantRules.emailLimit')))
        }else {
          callback()
        }
      }
      // 联系电话
      const validatorTelephone = (rule, value, callback) => {
        if(value.length > 510){
          callback(new Error(this.$t('relation.complainantRules.telephoneLimit')))
        }else{
          callback()
        }
      };
      return {
        limited: [{ required: true, trigger: 'change', message: this.$t('relation.complainantRules.limited') }],
        department: [{ required: true, trigger: 'blur', message: this.$t('relation.complainantRules.department') },{ min: 1, max: 510, message: this.$t('relation.complainantRules.departmentLimit'), trigger: 'blur' }],
        limitedText: [{ required: true, trigger: 'blur', message: this.$t('relation.complainantRules.limitedText') },{ min: 1, max: 510, message: this.$t('relation.complainantRules.limitedTextLimit'), trigger: 'blur' }],
        contactInformationFlag: [{ required: true, trigger: 'change', message: this.$t('relation.complainantRules.contactInformationFlag') }],
        complainName: [{ required: true, trigger: 'blur', message: this.$t('relation.complainantRules.complainName') },{ min: 1, max: 510, message: this.$t('relation.complainantRules.complainNameLimit'), trigger: 'blur' }],
        anonymousFlag: [{ required: true, trigger: 'change', message: this.$t('relation.complainantRules.anonymousFlag') }],
        telephone: [{ validator: validatorTelephone, trigger: 'blur' }],
        email: [{ trigger: 'blur', validator: validateEmail }]
      }
    },
    complaintRules() {
      // 表单验证
      const validateEventPlayers = (rule, value, callback) => {
        if (this.eventPlayers.length === 0) {
          callback(new Error(this.$t('relation.complaintRules.eventPlayers.Error')))
        } else {
          this.eventPlayers.forEach(item => {
            const { userName, department, position, managerFlag } = item
            if (!userName) {
              callback(new Error(this.$t('relation.complaintRules.eventPlayers.userName')))
            } else if (!department) {
              callback(new Error(this.$t('relation.complaintRules.eventPlayers.department')))
            } else if (!position) {
              callback(new Error(this.$t('relation.complaintRules.eventPlayers.position')))
            } else if (!managerFlag) {
              callback(new Error(this.$t('relation.complaintRules.eventPlayers.managerFlag')))
            }
            if(userName && userName.length > 510){
              callback(new Error(this.$t('relation.complaintRules.eventPlayers.userNameLimit')))
            }
            if(department && department.length > 510){
              callback(new Error(this.$t('relation.complaintRules.eventPlayers.departmentLimit')))
            }
            if(position && position.length > 510){
              callback(new Error(this.$t('relation.complaintRules.eventPlayers.positionLimit')))
            }
          })
          callback()
        }
      }
      const validateAuthenticatorList = (rule, value, callback) => {
        if (this.authenticatorList.length === 0) {
          callback(new Error(this.$t('relation.complaintRules.authenticatorList.Error')))
        } else {
          this.authenticatorList.forEach(item => {
            const { userName, department, position } = item
            if (!userName) {
              callback(new Error(this.$t('relation.complaintRules.authenticatorList.userName')))
            } else if (!department) {
              callback(new Error(this.$t('relation.complaintRules.authenticatorList.department')))
            } else if (!position) {
              callback(new Error(this.$t('relation.complaintRules.authenticatorList.position')))
            }
            if(userName && userName.length > 510){
              callback(new Error(this.$t('relation.complaintRules.authenticatorList.userNameLimit')))
            }
            if(department && department.length > 510){
              callback(new Error(this.$t('relation.complaintRules.authenticatorList.departmentLimit')))
            }
            if(position && position.length > 510){
              callback(new Error(this.$t('relation.complaintRules.authenticatorList.positionLimit')))
            }
          })
          callback()
        }
      }
      return {
        type: [{ required: true, trigger: 'change', message: this.$t('relation.complaintRules.type') }],
        eventTime: [{ required: true, trigger: 'change', message: this.$t('relation.complaintRules.eventTime') }],
        times: [{ trigger: 'blur', message: this.$t('relation.complaintRules.times') },{ min: 1, max: 510, message: this.$t('relation.complaintRules.timesLimit'), trigger: 'blur' }],
        frequency: [{ trigger: 'blur', message: this.$t('relation.complaintRules.frequency') },{ min: 1, max: 510, message: this.$t('relation.complaintRules.frequencyLimit'), trigger: 'blur' }],
        continueFlag: [{ required: true, trigger: 'change', message: this.$t('relation.complaintRules.continueFlag') }],
        eventPlayers: [{ required: true, trigger: 'click', validator: validateEventPlayers }],
        desInformation: [{ required: true, trigger: 'blur', message: this.$t('relation.complaintRules.desInformation') }],
        speechCompanyFlagFlag: [{ required: true, trigger: 'change', message: this.$t('relation.complaintRules.speechCompanyFlagFlag') }],
        speechCompanyFlag: [{ required: true, trigger: 'blur', message: this.$t('relation.complaintRules.speechCompanyFlag') }],
        speechOtherFlagFlag: [{ required: true, trigger: 'change', message: this.$t('relation.complaintRules.speechOtherFlagFlag') }],
        speechOtherFlag: [{ required: true, trigger: 'blur', message: this.$t('relation.complaintRules.speechOtherFlag') }],
        aboutOtherFlag: [{ required: true, trigger: 'change', message: this.$t('relation.complaintRules.aboutOtherFlag') }],
        otherDepartment: [{ required: true, trigger: 'blur', message: this.$t('relation.complaintRules.otherDepartment') },{ min: 1, max: 510, message: this.$t('relation.complaintRules.otherDepartmentLimit'), trigger: 'blur' }],
        witnessName: [{ required: true, trigger: 'change', message: this.$t('relation.complaintRules.witnessName') }],
        authenticatorList: [{ required: true, trigger: 'click', validator: validateAuthenticatorList }],
        howToKnow: [{ required: true, trigger: 'change', message: this.$t('relation.complaintRules.howToKnow') }]
      }
    },
    statementTitle() {
      return [this.$tc('statementText.statementTitle', 0), this.$tc('statementText.statementTitle', 1), this.$tc('statementText.statementTitle', 2)]
    },
    complainTypeList() {
      return [
          { value: 1, label: this.$t('complaintForm.complainTypeList.type1') },
          { value: 2, label: this.$t('complaintForm.complainTypeList.type2') },
          { value: 3, label: this.$t('complaintForm.complainTypeList.type3') },
          { value: 4, label: this.$t('complaintForm.complainTypeList.type4') },
          { value: 5, label: this.$t('complaintForm.complainTypeList.type5') },
          { value: 6, label: this.$t('complaintForm.complainTypeList.type6') },
          { value: 7, label: this.$t('complaintForm.complainTypeList.type7') },
          { value: 8, label: this.$t('complaintForm.complainTypeList.type8') },
          { value: 9, label: this.$t('complaintForm.complainTypeList.type9') },
          { value: 10, label: this.$t('complaintForm.complainTypeList.type10') },
        ]
    },
    desInformationPlaceholder() {
      return this.$t('complaintForm.desInformationPlaceholder')
    },
    speechOtherFlagPlaceholder() {
      return this.$t('complaintForm.speechOtherFlagPlaceholder')
    },
    speechCompanyFlagPlaceholder() {
      return this.$t('complaintForm.speechCompanyFlagPlaceholder')
    }
  },
  created() {
    getQuestionDicts('sys_admin_email_or_number', true).then(response => {
      this.adminEmailOrNumber = response.data[0].dictLabel
    })
  },
  mounted() {
    this.startStatementCountDown()
  },
  methods: {
    createCode() {
      const that = this
      getCodeImg().then(res => {
        const { data } = res
        if (data != null) {
          $('#imgCode').imgcode(
            {
              frontimg: 'data:image/png;base64,' +
                  data.slidingImage,
              backimg: 'data:image/png;base64,' +
                  data.backImage,
              yHeight: data.yHeight,
              msg: this.$t('msg.msg9'),
              refreshcallback: () => {
                // 刷新验证码
                that.createCode()
              },
              callback: function(msg) {
                let formData = {}
                formData.xpos = msg.xpos
                formData.capcode = data.capcode
                that.imgCode = this
                that.saveComplaint(formData)
              }
            })
        }
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.createCode()
        } else {
          return false
        }
      })
    },
    handleDeleteParticipant(index) {
      this.eventPlayers.splice(index, 1)
    },
    handleAddParticipant() {
      const item = { name: '', department: '', position: '', managerFlag: '' }
      this.eventPlayers.push(item)
    },
    handleDeleteWitness(index) {
      this.authenticatorList.splice(index, 1)
    },
    handleAddWitness() {
      const item = { name: '', department: '', position: '' }
      this.authenticatorList.push(item)
    },
    beforeUpload(file) {
      const type = file.name.split(".")[file.name.split(".").length - 1];
      if (!/jpg|png|gif|mp4|flv|wmv|avi|mkv|txt|xlsx|xls|vsdx|docx|doc|ppt|pptx/gi.test(type)) {
        this.$message.warning(this.$t('msg.msg12'))
        return false
      }
      if (file.size >= 500000000) {
        this.$message.warning(this.$t('msg.msg11'))
        return false
      }
    },
    saveFile(response, file) {
      if (response.code === 200) {
        const list = {
          fileName: response.data.fileName,
          filePath: response.data.url,
          uid: file.uid
        }
        this.sysFiles.push(list)
      } else {
        if (response.msg) {
          this.$message.error(response.msg)
        } else {
          this.$message.error(this.$t('msg.msg4'))
        }
        this.$refs.fileUpload.handleRemove(file)
      }
    },
    fileExceed() {
      this.$message.warning(this.$t('msg.msg5'))
    },
    remove(file) {
      this.sysFiles.forEach((item, index) => {
        if (item.uid === file.uid) {
          this.sysFiles.splice(index, 1)
        }
      })
    },
    saveComplaint(formData) {
      if (this.saveComplaintFlag) {
        return
      } else {
        this.saveComplaintFlag = true
      }
      let complaintForm = JSON.parse(JSON.stringify(this.complaintForm))
      let authenticatorList = JSON.parse(JSON.stringify(this.authenticatorList))
      let eventPlayers = JSON.parse(JSON.stringify(this.eventPlayers))

      complaintForm.located = this.complaintForm.located.toString()
      complaintForm.misconductOccur = this.complaintForm.misconductOccur.toString()
      // 赋值其他关系信息、清除备选项
      if (this.complaintForm.limited !== 1) {
        complaintForm.department = ''
      }
      if (this.complaintForm.limited === 4) {
        complaintForm.limited = this.complaintForm.limitedText
      } else {
        complaintForm.limited = this.$t('relation.limiteds.value' + this.complaintForm.limited)
      }
      if (this.complaintForm.contactInformationFlag === '2') {
        complaintForm.telephone = ''
        complaintForm.email = ''
      }
      if (this.complaintForm.anonymousFlag === '1') {
        complaintForm.complainName = ''
      }
      if (this.complaintForm.speechCompanyFlagFlag === '2') {
        complaintForm.speechCompanyFlag = ''
      }
      if (this.complaintForm.speechOtherFlagFlag === '2') {
        complaintForm.speechOtherFlag = ''
      }
      if (this.complaintForm.witnessName !== 'yes') {
        authenticatorList = []
      }
      if (this.complaintForm.aboutOtherFlag !== 'yes') {
        complaintForm.otherDepartment = ''
      }
      complaintForm.type = this.$t('complaintForm.complainTypeList.type' + this.complaintForm.type)
      complaintForm.continueFlag = this.$t('complaintForm.continueFlagSelect.' + this.complaintForm.continueFlag)
      this.eventPlayers.forEach((item,index) => {
        eventPlayers[index].managerFlag = this.$t('complaintForm.continueFlagSelect.' + item.managerFlag)
      })
      complaintForm.aboutOtherFlag =  this.$t('complaintForm.aboutOtherFlagSelect.' + this.complaintForm.aboutOtherFlag)
      complaintForm.witnessName =  this.$t('complaintForm.witnessNameSelect.' + this.complaintForm.witnessName)
      complaintForm.howToKnow =  this.$t('complaintForm.howToKnowSelect.' + this.complaintForm.howToKnow)

      const data = {
        complainForm: complaintForm,
        eventPlayers: eventPlayers,
        authenticatorList: authenticatorList,
        sysFiles: this.sysFiles,
        xpos: formData.xpos,
        capcode: formData.capcode
        // formKey: this.complaintForm.formKey
      }

      saveComplaint(data).then((res) => {
        this.formId = res.data.formId
        this.formKey = res.data.formKey
        this.$store.dispatch('app/setKey', this.formKey)

        this.$message.success(this.$t('msg.msg6'))
        this.stepAction = 4
      }).catch(err => {
        this.saveComplaintFlag = false
        if (err.message === '验证图片已失效,请重新获取') {
          this.imgCode.getfail(this.$t('msg.msg7'))
        } else {
          this.imgCode.getfail(this.$t('msg.msg8'))
        }
      }).finally(() => {
        setTimeout(() => {
          if (document.getElementById('imgCode')) {
            document.getElementById('imgCode').innerHTML = ''
          }
        }, 300)
      })
    },
    startStatementCountDown() {
      this.statementCountDown = 5 // 倒计时秒钟
      const begin = setInterval(() => {
        if (this.statementCountDown !== 0) {
          this.statementCountDown--
        } else {
          clearInterval(begin)
        }
      }, 1000)
    },
    haveRead() {
      this.showStatement[this.stepAction] = false
      this.statementChecked = false
    },
    previousStep() {
      if (this.stepAction !== 0) {
        this.stepAction--
      }
    },
    nextStep(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.stepAction++
          this.startStatementCountDown()
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .complaint{
    padding: 0 20px 0 20px;
    .complaint-content {
      .statement{
        .statement-title {
          text-align: center;
          margin-top: 10px;
          font-size: 22px;
          font-weight: bold;
        }
        .statement-text {
          word-break: break-all;
          font-size: 20px;
        }
        .statement-btn {
          text-align: center;
          margin-top: 50px;
          font-size: 22px;
        }
        &.statement-zh p{
          text-indent: 40px;
        }

      }
      .submit-form{
        font-size: 20px;
        .el-cascader,.el-select{
          width: 100%;
        }
        .title{
          color: #0463a8;
          font-size: 22px;
          font-weight: bold;
          border-bottom: #dcdfe6 1px dashed;
        }
        .form-next-btn{
          text-align: center;
          margin-top: 30px;
        }
      }
      .complaint-confirmation {
        font-size: 20px;
        margin-top: 80px;
        text-align: center;
        div {
          margin-top: 80px;
          .form-id {
            color: #e60000;
          }
        }
      }
    }
    /deep/ .el-form-item__error{
      top: auto;
    }
    /deep/ .el-table__header{
      width: 100%!important;
    }
    /deep/ .el-table__body{
      width: 100%!important;
    }
    /deep/ .el-dialog--center .el-dialog__body{
      text-align: left;
    }
    /deep/ .colCenter{
      margin: auto;
      float: none;
    }
    /deep/ .longLabel el-form-item__label{
      width: 600px;
    }
  }

</style>
